import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

export default function Breadcrumbs({ items = [] }) {
  return (
    <nav className="flex flex-wrap items-center gap-1.5 text-sm" data-testid="breadcrumbs">
      <Link to="/" className="flex items-center gap-1 text-muted-foreground hover:text-primary"><Home className="h-3.5 w-3.5" /></Link>
      {items.map((it, i) => (
        <span key={i} className="flex items-center gap-1.5">
          <ChevronRight className="h-3.5 w-3.5 text-muted-foreground" />
          {it.to && i < items.length - 1 ? (
            <Link to={it.to} className="text-muted-foreground hover:text-primary">{it.label}</Link>
          ) : (
            <span className="font-medium text-foreground">{it.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}
